import { render, staticRenderFns } from "./Prelievo.vue?vue&type=template&id=c6e2409c&scoped=true&"
import script from "./Prelievo.vue?vue&type=script&lang=js&"
export * from "./Prelievo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e2409c",
  null
  
)

export default component.exports